import { FirearmAssignmentLogResolverBase } from './firearm-assignment-log.resolver.base';
import { FirearmAssignmentLogService } from './firearm-assignment-log.service';
import { Injectable } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class FirearmAssignmentLogResolver extends FirearmAssignmentLogResolverBase {

  constructor(protected service: FirearmAssignmentLogService) {
    super(service);
  }
}



